// extracted by mini-css-extract-plugin
export default {"container":"loader_container__NkvUA","logo":"loader_logo__rANTv","spin":"loader_spin__yL8we","pulse":"loader_pulse__T9Ehq","text":"loader_text__KPU1H","fade":"loader_fade__ezOV5"};